import React from 'react';
import { Redirect } from 'react-router-dom';

import reqwest from 'reqwest';

import settings from '../../settings';
import LoginForm from '../components/LoginForm';

const LoginRoute = () => {
  if (localStorage.getItem('token')) {
    console.log('t');
    reqwest({
      method: 'get',
      url: settings.general.checkToken,
      data: {
        Token: localStorage.getItem('token'),
      },
    }).then(res => {
      if (res === true) {
        return (
          <Redirect
            to={{
              pathname: '/',
            }}
          />
        );
      } else {
        localStorage.clear();
      }
    });
  }
  return <LoginForm />;
};

export default LoginRoute;
